import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { ZegoExpressEngine } from "zego-express-engine-webrtc";
import PerformerStream from "./PerformerStream";
import { zegoInit } from "./../../../utils/zegoInit";
import { useAuth } from "../../../hooks";

export function PerformerPage() {
  const { channel_name } = useParams();
  const navigate = useNavigate();
  const [zg, setZg] = useState<ZegoExpressEngine | null>(null);
  const [params] = useSearchParams();
  const performerName = params.get("performerName") || "Performer";
  const { userInfo } = useAuth();

  useEffect(() => {
    try {
      const zego = zegoInit();
      setZg(zego);
      console.log("[Zego] Performer Engine initialized", zego);
    } catch (error) {
      console.error("[Zego] Performer Init failed:", error);
    }
  }, [channel_name, userInfo?.id]);

  const handleCallEnd = () => {
    navigate(-1);
  };

  if (!userInfo?.id) return <></>;

  return (
    <>
      <PerformerStream
        onCallEnd={handleCallEnd}
        userId={userInfo?.id?.toString() ?? ""}
        videoId={channel_name!}
        zg={zg}
        performerName={performerName}
      />
    </>
  );
}

export default PerformerPage;
